<template>
  <div id="app">
    <!-- Survey Banner || Uncomment, rebuild, and redeploy at the end of Day 1 -->
    <div class="survey-banner">
      <a href="https://oxford.club/survey" target="_blank">
        <div class="container-full">
          <div class="row">
            <div class="col">
              <h2><strong>Please click here to take a quick survey to let us know what you think of the event and how we can improve!</strong></h2>
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="header">
      <div class="container">
        <div class="row">
          <div class="header-col-center">
            <router-link to="/"><img class="logos" v-bind:src="options.livestream_logo" viewBox="0 0 250 250"></router-link>
          </div>
        </div>
      </div>
      <div class="container-full">
        <div class="row gradient">
          <div class="col content">
            <p class="hLine01">The Oxford Club's Private Wealth Seminars</p>
            <p class="hLine02">Cliff House, Maine Livestream</p>
          </div>
        </div>
      </div>
    </div>
    <nav class="main-menu">
      <div class="container">
        <div class="row">
          <ul class="nav">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/archive/1">Day 1</router-link></li>
            <li><router-link to="/archive/2">Day 2</router-link></li>
            <li><router-link to="/schedule">Schedule</router-link></li>
            <li><router-link to="/recommendations">Recommendations</router-link></li>
            <li><router-link to="/faq">FAQ</router-link></li>
          </ul>
        </div>
      </div>
    </nav>
    <router-view/>
    <div class="footer">
      <div class="container">
        <p>The Oxford Club, as the sponsoring organization of this conference, provides a forum for speakers we believe have useful and reliable information for you. While we believe these speakers provide accurate and reliable information, we cannot guarantee the accuracy and reliability of the information provided, nor are we responsible for any errors or omissions by speakers. The Oxford Club, its agents and other sponsoring groups do not, at any time, provide individual, personalized business or investment advice. Agents of The Oxford Club appearing and speaking at this conference present information for the general public and at no time should any person acting as an agent for The Oxford Club and/or its affiliates be relied upon or construed as rendering personalized advice. Information provided by The Oxford Club and its agents is of a general nature and not tailored to your specific situation, nor should any statements be considered as such.</p>

        <p>We do not institutionally endorse and/or recommend securities and/or private placements mentioned by these speakers. Some speakers are licensed advisors who manage private financial advice services separate from and unrelated to The Oxford Club and/or its affiliates. Advertising you may receive from their companies should not be construed as originating from or connected in any way to The Oxford Club.</p>
      </div>
    </div>
  </div>
</template>

<script>
import db from './db';

export default {
  name: 'App',
  firebase: {
    options: {
      source: db.ref('options'),
      asObject: true,
    },
  },
};
</script>

<style>
/** Defaults */

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

img {
  max-width: 100%;
}

h1 {
  margin-top: 0;
}

/* This doesn't work from LiveBlog component for some reason */
.entry > h2, .entry > h3 {
  margin-top: 0;
}
.entry img {
  margin: 20px 0;
}

/* Survey */
.survey-banner {
  background: linear-gradient(220deg, #ff931e 0%,#fccb96 100%); ;
  width: 100%;
  margin: 0 auto 1em;
  text-align: center;
}
.survey-banner a {
  text-align: center;
  text-decoration: none;
}
.survey-banner a h2 {
  font-size: 1.25em;
  color: #274766;
  margin: 0;
  padding: 1em 0;
}

/** Header */

.header {
  clear: both;
  margin-bottom: 15px;
  /* max-height: 2000px; */
}
.header-col-left, .header-col-right {
  float: left;
  width: 48%;
}
.header-col-center {
  margin: auto;
}
.logos {
  margin-top: 15px;
  margin-bottom: 10px;
  height: 75px;
}
.header-col-right {
  float: right;
  text-align: right;
}
.header-col-right > img {
  max-width: 350px;
}

@media (max-width: 685px) {
  .header-col-left {
    width: 100%;
    text-align: center;
  }
  .header-col-left img { max-width: 500px; }
  .header-col-right { display: none; }
}

.gradient {
  background: linear-gradient(45deg, #499eac 0%,#274766 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#499eac', endColorstr='#274766',GradientType=1 );
}

.gradient p {
  text-align: center;
  text-transform: uppercase;
  color: #fdfdfd;
}

.hLine01 {
  font-size: 18px;
  margin: 15px 0px 0px 0px;
}

.hLine02 {
  font-size: 32px;
  font-weight: bold;
  margin: 0px 0px 15px 0px;
}
/** Navigation */

.main-menu {
  background-color: white;
  box-shadow: #ccc 0 1px 1px;
  border-radius: 0;
  min-height: 0;
  margin-bottom: 24px;
}
.nav {
  list-style: none;
  margin: auto;
  padding: 0 0 6px;
}
.nav > li {
  float: left;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
}
.nav > li > a {
  background-color: white;
  color: #274766;
  padding: 0.6em 1.6em;
  font-weight: bold;
  line-height: 20px;
  text-decoration: none;
  text-transform: uppercase;
}
.nav > li > a:hover {
  background-color: #eee;
  color: #333333;
}


/** Grid System */

.container {
  max-width: 960px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}

.row {
  box-sizing: border-box;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex: 0 1 auto;
  -webkit-box-flex: 0;
  flex: 0 1 auto;
  -ms-flex-direction: row;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-right: -15px;
}
.row:before {
  content: " ";
  display: table;
}
.row:after {
  clear: both;
  content: "";
  display: table;
}

.container-full {
  width: 100%;
  height: 100%;
}

.col {
  position: relative;
  min-height: 1px;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
}


/** Layout */

.content {
  width: 100%;
  float: center;
}

@media (max-width: 1005px) {
  .content, .sidebar { width: 100%; }
}


/** Schedule */

.schedule-col {
  border-radius: .25rem;
}

.schedule-col-contents {
  border-radius: .25rem;
  background-color: transparent;
  text-align: left;
  font-weight: bold;
  background-position: left 12px;
  background-repeat: no-repeat;
  border: 1px solid #ddd;
  margin-bottom: 2em;
}

.schedule-col-header {
  border-radius: .25rem .25rem 0px 0px;
  color: #fdfdfd;
  background-color: #274766;
  font-weight: bold;
  margin: 0;
  padding: 12px 12px 8px;
  font-size: 1.2em;
}

.schedule-col-section {
  padding: 1em;
  background-color: #27476600;
}

.schedule-col-section:nth-child(odd) {
  border-top: 1px solid #ddd;
  background-color: #27476612;
  text-align: left;
  color: #000000;
  font-weight: bold;
  background-position: left 12px;
  background-repeat: no-repeat;
}

.schedule-col-section:last-of-type {
  border-radius: 0px 0px .25rem .25rem;
}

.presentation-speaker {
  font-size: 1.3em;
  margin-top: 0;
  margin-bottom: 0.4em;
}

.presentation-time {
  margin-bottom: 0.4em;
}

.presentation-link > a {
  color: #274766;
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 0;
}


/** Footer */

.footer {
  color: #555;
  padding: 2em 0;
  margin-top: 2em;
  background-color: #ffffff;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0b182b', endColorstr='#1d467e',GradientType=0 );
}

.footer p {
  font-size: 0.85em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue